import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=2640a886&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=2640a886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640a886",
  null
  
)

export default component.exports